import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

import { fieldShape } from './index.shape';
import { addClassName } from './index.utils';

import './index.scss';

/**
 * text field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const InputCommon = props => {
  const {
    field: { name, value },
    placeholder,
    disabled,
    eventEmitter,
    showError,
    existError,
    ...other
  } = props;
  const [localValue, setValueLocal] = useState(value);

  // TODO observable value
  useEffect(() => {
    setValueLocal(value);
  }, [value]);

  // on change value
  const onChange = event => setValueLocal(get(event, 'target.value'));

  // on blur value
  const onBlur = () => eventEmitter(localValue);

  return (
    <input
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      className={addClassName({ existError, showError })}
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      value={localValue || ''}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
};

InputCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
};

InputCommon.defaultProps = {
  field: {
    value: undefined,
  },
  existError: false,
  showError: false,
  placeholder: '',
  disabled: false,
};

export default InputCommon;
